import React from "react";

export default function Error404() {
  return <>ERROR 404</>;
}
